// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kvz-c","row":"Footer_row__V6HBu","verticalBox":"Footer_verticalBox__XgFVX","link":"Footer_link__mWuLL"};